module.exports = __webpack_public_path__ + "img/lever01.bdf3bf1a.png";